import { render, staticRenderFns } from "./TabContasPagar.vue?vue&type=template&id=7c384b8a&scoped=true&"
import script from "./TabContasPagar.vue?vue&type=script&setup=true&lang=js&"
export * from "./TabContasPagar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c384b8a",
  null
  
)

export default component.exports